module.exports = __webpack_public_path__ + "img/icon-02.107b8b4e.png";